// src/components/WhyRaiseYourVoiceSection.jsx
import { motion } from "framer-motion";
import React from "react";

const WhyRaiseYourVoiceSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-orange-100 via-white to-green-100 py-20 px-4 overflow-hidden">
      {/* Tricolor Shadow Overlay */}
      <div className="absolute inset-0 z-0 opacity-20 blur-sm bg-[url('https://images.unsplash.com/photo-1597213693685-3a7391d9b2b6?auto=format&fit=crop&w=1400&q=80')] bg-cover bg-center" />

      {/* Main Content */}
      <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        
        {/* Left: Text */}
        <div className="text-center md:text-left">
          <motion.h2
            className="text-4xl sm:text-5xl font-extrabold text-orange-700 mb-4 drop-shadow-sm"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            क्यों उठाएं अपनी आवाज़?
          </motion.h2>

          <motion.p
            className="text-gray-800 text-lg max-w-md mx-auto md:mx-0"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            आपके गांव को पानी चाहिए। आपके बच्चों को शिक्षा चाहिए। आपके नेताओं को जवाबदेह बनाना होगा।  
            <strong className="text-green-700">जनशक्ति</strong> आपको ताकत देता है अपनी समस्याएं उठाने की — और बदलाव लाने की। 
          </motion.p>

          <motion.div
            className="mt-8"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
          >
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="bg-orange-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-700 transition"
            >
              ✊ Raise an Issue Now
            </button>
          </motion.div>
        </div>

        {/* Right: Graphic */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
          className="flex justify-center"
        >
          <img
            src="/assets/images/raise-voice-banner.png"
            alt="Why Raise Your Voice - JanShakti"
            className="w-full max-w-xl rounded-xl shadow-md object-cover"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default WhyRaiseYourVoiceSection;
